import React from "react";
import { Volume2, Square } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Subtle speaker icon rendered inside rewritten (AI) bubbles. Low opacity
 * by default; pops to full on hover or while active. Tap again to stop.
 * Optimized for the dark background of "mine" / improved bubbles, but
 * falls back gracefully on light backgrounds too.
 */
const SpeakerButton = ({
    isPlaying,
    onToggle,
    disabled = false,
    variant = "dark", // 'dark' (on stone-800 bubble) or 'light'
    className,
}) => {
    const base =
        "inline-flex items-center justify-center h-6 w-6 rounded-full transition-all shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-white/40";

    const theme =
        variant === "light"
            ? isPlaying
                ? "bg-[#EAF1E8] text-[#4B6143] opacity-100 ring-1 ring-[#5E7153]/40"
                : "text-stone-400 hover:text-stone-700 opacity-60 hover:opacity-100"
            : isPlaying
              ? "bg-white/15 text-white opacity-100 ring-1 ring-white/35"
              : "text-stone-300/80 hover:text-white opacity-60 hover:opacity-100 hover:bg-white/10";

    return (
        <button
            type="button"
            data-testid="btn-play-audio"
            data-playing={isPlaying ? "true" : "false"}
            onClick={onToggle}
            disabled={disabled}
            aria-label={isPlaying ? "Stop audio" : "Play message audio"}
            aria-pressed={isPlaying}
            className={cn(
                base,
                theme,
                disabled && "opacity-30 cursor-not-allowed",
                className,
            )}
        >
            {isPlaying ? (
                <Square className="h-3 w-3 fill-current" />
            ) : (
                <Volume2 className="h-3.5 w-3.5" />
            )}
        </button>
    );
};

export default SpeakerButton;
